<template>
  <div>
    <div
      v-if="isMobile"
      class="absolute pin-t w-full"
      :class="$style['background-image']"
      :style="{ backgroundImage: 'url('+ require('@/assets/images/cabecera_mobile.png') +')' }"
    />

    <div
      v-else
      class="absolute pin-t w-full"
      :class="$style['background-image']"
      :style="{ backgroundImage: 'url('+ require('@/assets/images/cabecera.png') +')' }"
    />

    <div
      class="mx-auto"
      :class="$style['box']"
    >
      <div class="relative z-10 px-10 sm:px-0">
        <div v-if="$route.name === 'site'">
          <a
            href="javascript:;"
            class="mt-10 md:mt-5"
            @click="scrollToId('signup')"
          >
            Quiero dar un paseo
          </a>
          <br><br>
          <img
            src="@/assets/images/arrow1.png"
            @click="scrollToId('signup')"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  components: {
  },

  data () {
    return {
      breakpoint: 0
    }
  },

  watch: {
    breakpoint: {
      immediate: true,
      handler: function (newBreakpoint, oldBreakpoint) {}
    }
  },

  computed: {
    isSuccessPage () {
      return this.$route.name === 'success'
    },

    isMobile () {
      return this.breakpoint < 768
    }
  },

  created () {
    this.refreshBreakpoint()
    window.addEventListener('resize', _.throttle(this.refreshBreakpoint))
  },

  beforeDestroy () {
    window.removeEventListener('resize', _.throttle(this.refreshBreakpoint))
  },

  methods: {
    refreshBreakpoint () {
      this.breakpoint = parseInt(window
        .getComputedStyle(document.querySelector('body'), ':before')
        .getPropertyValue('content')
        .replace(/"/g, ''))
    },

    scrollToId (id) {
      document.getElementById(id).scrollIntoView({ behaviour: 'smooth' })
    }
  }
}
</script>

<style lang="scss" module>
.box {
  max-width: 1200px;
  padding-top: 570px;
  text-align: center;
}

.background-image {
  height: 650px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}

.title {
  font-size: 44px;
  line-height: 40px;
  font-weight: 600;
  color: white;
  text-align: left;
  @apply font-vw-head;

  & > p {
    @apply mt-5;
    font-size: 22px;
    line-height: 26px;
  }
}

@media (min-width: 576px) {
  .title {
    font-size: 58px;
    line-height: 56px;
    color: white;
    @apply mt-5;

    & > p {
      font-size: 24px;
      line-height: 31px;
    }
  }
}

@media (min-width: 768px) {
  .title {
    font-size: 76px;
    line-height: 68px;
    margin-bottom: 40px;
  }
}
</style>
